<template>
  <component :is="component" v-bind="componentProps" class="AppSpinner" />
</template>

<script>
  import { LoopingRhombusesSpinner, HalfCircleSpinner } from 'epic-spinners'

  export default {
    props: {
      component: {
        type: String,
        default: 'looping-rhombuses-spinner'
      },
      animationDuration: {
        type: Number,
        default: 2500
      },
      color: {
        type: String,
        default: '#fff'
      },
      size: {
        type: Number,
        default: null
      },
      rhombusSize: {
        type: Number,
        default: 10
      }
    },

    data () {
      return {
        componentProps: {
          animationDuration: this.animationDuration,
          rhombusSize: this.rhombusSize,
          color: this.color,
          size: this.size
        }
      }
    },

    components: {
      LoopingRhombusesSpinner,
      HalfCircleSpinner
    }
  }
</script>
